module.exports = __webpack_public_path__ + "img/Packing.6d0d7860.png";